/** The end message the backend streams and saves when the user stops a reply. */
export const STOP_NOTICE_TEXT = 'User has interrupted.';

/** Shown in place of a reply that ended without sending anything. */
export const NO_REPLY_TEXT = 'No reply was received';

/**
 * The stop notice is a neutral note, not an error. Prefers the backend's `reason`, and falls back
 * to the wording for streams and saved rows that don't carry one.
 */
export function isStopNotice(text: string | null | undefined, reason?: string | null): boolean {
    if (reason === 'interrupted') return true;
    return typeof text === 'string' && /^user has interrupted\.?$/i.test(text.trim());
}

export function isStoppedStatus(status: string | null | undefined): boolean {
    return status === 'STOPPED';
}
